
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { logoutUser } from "../actions/auth"

const Logout = ({ logoutUser }) => {

  useEffect(() => {
    logoutUser()
  }, [logoutUser]);

  return <Redirect to="/login" />

}

export default connect(null, { logoutUser }) (Logout);